import { SignatureResponse } from "@smart/bridge-types-basic";
import { specialChars } from "@smart/itops-utils-basic";

import { getUITranslation } from "../../utils";
import { DigitalSignatureField } from "../field-components/signature-field/digital-signature-field";

export const SummarySignature = ({
  response,
  isDigitalSignature,
  fieldUri,
  selectedLanguage,
}: {
  response: SignatureResponse;
  isDigitalSignature: boolean;
  fieldUri: string;
  selectedLanguage?: string;
}) => {
  if (isDigitalSignature) {
    return <DigitalSignatureField selectedLanguage={selectedLanguage} />;
  }
  if (response?.mode === "draw" && response?.data) {
    return (
      <img
        src={`data:image/png;base64,${response.data}`}
        alt={getUITranslation("signature", selectedLanguage)}
        className="h-[15rem] w-full object-contain border border-solid rounded-[var(--input-brand-radius,0.8rem)] border-neutral-200 bg-neutral-20"
        data-testid={`signature-field-item-${fieldUri}`}
      />
    );
  }
  if (response?.mode === "type" && response?.text) {
    return (
      <p
        className="flex w-full h-[15rem] items-center justify-center border border-solid rounded-[var(--input-brand-radius,0.8rem)] border-neutral-200 bg-neutral-20 text-signature font-birthstone"
        data-testid={`signature-field-item-${fieldUri}`}
      >
        {response.text}
      </p>
    );
  }

  return <p className="text-ui">{specialChars.enDash}</p>;
};
